module.exports = __webpack_public_path__ + "static/background-8624631b38886e5fe17d4877428f901f.jpg";